import { render, staticRenderFns } from "./Repairs.vue?vue&type=template&id=5a41d85b&scoped=true&"
import script from "./Repairs.vue?vue&type=script&lang=js&"
export * from "./Repairs.vue?vue&type=script&lang=js&"
import style0 from "./Repairs.vue?vue&type=style&index=0&id=5a41d85b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a41d85b",
  null
  
)

export default component.exports